import React from "react";
import { useSelector } from "react-redux";
import TableWithCustomSearch from "../../../../../components/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";
import ReactTooltip from "react-tooltip";

const RiskMembersTable = () => {
  const {
    data = [],
    colHeaders = [],
    columns,
    rawDataLink,
    colHeaderTooltips = []
  } = useSelector((state) => state.riskMembers.table);

  const columnHeaderSlot = colHeaderTooltips.reduce((acc, column) => {
    acc[column.columnHeader] = (
      <div className="d-inline" data-for="risk-members-table" data-tip={column?.tooltip}>
        {column?.label}
      </div>
    );
    return acc;
  }, {});

  return (
    <>
      <TableWithCustomSearch
        fileName="risk-members-logs"
        data={data}
        colHeaders={colHeaders}
        columns={columns}
        rawDataLink={rawDataLink}
        noDataMessage="No data available for today."
        columnHeaderSlot={columnHeaderSlot}
      />
      <ReactTooltip id="risk-members-table" />
    </>
  );
};

export default RiskMembersTable;
